import { __extends } from "tslib";
import InfiniteScroll from 'react-infinite-scroller';
/**
 * react-infinite-scroller re-attaches scroll/resize/mousewheel listeners on every
 * componentDidUpdate without detaching first, which stacks handlers and re-runs
 * scrollListener when initialLoad is true. Detach before attach to keep one set.
 */
// Library typings omit attach/detach; runtime class has them.
var InfiniteScrollClass = InfiniteScroll;
var StableInfiniteScroll = /** @class */ (function (_super) {
    __extends(StableInfiniteScroll, _super);
    function StableInfiniteScroll() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StableInfiniteScroll.prototype.attachScrollListener = function () {
        if (typeof this.detachScrollListener === 'function') {
            this.detachScrollListener();
        }
        if (typeof this.detachMousewheelListener === 'function') {
            this.detachMousewheelListener();
        }
        InfiniteScrollClass.prototype.attachScrollListener.call(this);
    };
    return StableInfiniteScroll;
}(InfiniteScrollClass));
export default StableInfiniteScroll;
//# sourceMappingURL=StableInfiniteScroll.js.map